import { ChatHistoryRequest } from 'model/chatHistory/chatHistory.request';
import { ChatHistoryResponse } from 'model/chatHistory/chatHistory.response';
import { ApiConfig } from 'config/api.config';
import { convertBriteClient } from 'utils/convertBriteClient';

export const getChatHistory = async (params: ChatHistoryRequest): Promise<ChatHistoryResponse> => {
  try {
    const data = await convertBriteClient.post<ChatHistoryResponse>(ApiConfig.CHAT_HISTORY, params);
    return data;
  } catch (error) {
    console.error('Error fetching chat history:', error);
    return {
      chats: [],
      total_rec: 0,
    };
  }
};
